@if (busy()) {
  <div class="flex h-6 w-6 items-center justify-center rounded-full bg-shikenso-base-white">
    <app-dots-spinner />
  </div>
} @else if (pendingDeletion() || deletable()) {
  <button
    mat-icon-button
    type="button"
    class="mat-white-icon-button"
    [attr.aria-label]="'pages.campaignDetails.ctaAnalytics.details.findingCards.moreActions' | translate"
    [matMenuTriggerFor]="findingMenu"
  >
    <app-icon src="/icons/three-dots.svg" alt="" [size]="16" />
  </button>

  <mat-menu #findingMenu="matMenu" xPosition="before">
    @if (pendingDeletion()) {
      <button mat-menu-item type="button" (click)="revertFinding.emit()">
        <div class="flex items-center gap-2">
          <app-icon src="/icons/redo.svg" alt="" [size]="16" />
          <span>{{ 'shared.revert' | translate }}</span>
        </div>
      </button>
    } @else {
      <button mat-menu-item type="button" (click)="deleteFinding.emit()">
        <div class="flex items-center gap-2">
          <app-icon src="/icons/trash.svg" alt="" [size]="16" />
          <span>{{ 'shared.delete' | translate }}</span>
        </div>
      </button>
    }
  </mat-menu>
}
